module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "3em"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "padding": "2em"
    }
  }, [_vm._v("Our Business Partners")]), _vm._v(" "), _c('div', {
    staticClass: " col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"
  }, _vm._l((_vm.bps), function(bp, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-6 col-sm-4 col-md-3 bp"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/mybp/' + bp.img,
        "alt": bp.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bpc col-xs-12"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/bp/' + bp.img,
        "alt": bp.img
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "cta-section-2"
  }, [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Check out our products!")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-item about-history"
  }, [_c('div', {
    staticClass: "about-item-info col-md-6 col-xs-12"
  }, [_c('h1', [_vm._v("Company History")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tEstablished in 1987, Mutual Success Lighting Fixture Inc., has maintained its position as a quality lighting provider in the industry.\n\t\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\tWith its over twenty-five (25) years of continuous innovation, customer service and excellence, the company relatively expanded, numerically evident by the availability of product lines in more than 200 major depots and DIY's nationwide.\n\t\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\tIt is the commitment to exceeding the needs of the household and construction industry that makes the company go further. The company ensures that its importation will give customers a wide array of lighting designs and functionalities at reasonable cost. As an observance to quality standards, the products are CE, ICC and DTI certified.\n\t\t\t\t\t"), _c('br'), _c('br'), _vm._v("\n\t\t\t\t\tMutual Success Lighting Fixture Inc. offers all types of lighting requirements. From ambient lighting to general lighting, from accent and task lighting to outdoor and industrial lighting; all of which have the objective of providing lighting needs and satisfaction essential to daily living.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-item-info col-md-6 col-xs-12 pull-right"
  }, [_c('h1', [_vm._v("Vision")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tTo be a major player in the industry recognized for its pursuits of sustainability and principle.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-item-info col-md-6 col-xs-12"
  }, [_c('h1', [_vm._v("Mission")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tTo be a one-stop quality lighting provider for the household and construction industry and go beyond customers' expectations through commitment to operational excellence, performance, innovation; customer-centrism and integrity.\n\t\t\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-706e904d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 156
// module chunks = 0